export const TILL_NUMBER = "TILL_NUMBER";
export const PAYBILL = "PAYBILL";
export const OCCUPANT_TYPE = "property_management";

export const colorTheme = {
    primary:{
        10: "#f9f9fe",
        25: '#F2F2FF', // Very light blue
        50: '#E4E4FF', // Pale blue
        75: "#3880ff", // Light blue (Ionic color)
        100: '#B2B3FF', // Light blue
        200: '#7F80FF', // Soft blue
        300: '#4C4DFF', // Medium blue
        350: "#428cff", //sky blue or primary ionic color
        400: '#1A1AFF', // Deep blue
        500: '#0000E6', // Blue
        600: '#0000B4', // Dark blue
        700: '#000082', // Navy blue
        800: '#000050', // Very dark blue
        900: '#000021', // Almost black blue
    }
}

export const MONTHS = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December"
];

export const UNIFORM_RESOURCE_LOCATORS = {
    tenants: '/tenants',
    tenantTransactions: '/tenants/details',
    utilities: '/utilities',
    team: '/settings/team',
    units: '/units',
    properties: '/properties',
    maintenance: '/maintenance',
    maintenanceForm: '/maintenance/maintenance-form',
    landlords: '/settings/landlords',
    payments: '/financials/payments',
    bankStatement: '/financials/bank-statement',
    invoices: '/financials/invoices',
    expenses: '/financials/expenses',
    expenseForm: '/financials/expenses/expense-form',
    dashboard: '/dashboard',
    withdrawals: '/settings/withdrawals',
    withdrawalsAmount: '/settings/withdrawals/withdrawals-amount',
    withdrawalsAccount: '/settings/withdrawals/withdrawals-account',
    billing: '/settings/billing',
    accountInfo: '/settings/account',
    changePassword: '/change-password',
    mpesa: '/settings/billing/mpesa',
    landlordLogin: '/login/landlord',
    welcome: '/welcome',
    reports: '/reports',
    onBoarding: '/onboarding',
    propertyForm: '/property-form',
    unitForm: '/unit-form',
    tenantForm: '/tenant-form',
    teamForm: '/team-form',
    invoiceForm: '/invoice-form',
    bulkCreateInvoices: '/bulk-create-invoices-form',
    messages: '/communication',
    folderInbox: '/folder/Inbox',
    appLogin: '/login',
    generalFolder: '/folder/',
    error404: '/pages/error-404',
    generalSettings: '/settings/general',
    alertSettings: '/settings/alerts',
    subscriptionExpired: '/subscription-expired',
    survey: '/new-user-survey',
    creditCard: '/billing/credit-card',
    pricing: '/settings/billing/checkout'
}

export const TENANT_APP_URLS = {
    login: '/login/tenant',
    home: '/t/home',
    maintenance: '/t/maintenance',
    financials: '/t/financials',
    payrent: '/t/payrent',
    properties: '/t/properties',
}

export const PAGES_NOT_TO_SHOW_SPLIT_PANE = [
    UNIFORM_RESOURCE_LOCATORS.appLogin
]

export const NOTIFICATION_TYPES = {
    payment_reminder: 'payment_reminder',
    payment_summary: 'payment_summary',
    invoice_generation_reminder: 'invoice_generation_reminder',
    utility_bill_generation_reminder: 'utility_bill_generation_reminder',
    unassigned_payment_summary: 'unassigned_payment_summary',
    automated_task_completed: 'automated_task_completed',
};

export const AUTOMATED_TASK_NAMES = {
    automaticInvoiceGeneration: 'automatic_invoice_generation',
    automaticTenantBalanceReminder: 'automatic_tenant_balance_reminder',
};